import { render, staticRenderFns } from "./exitBlacklist.vue?vue&type=template&id=0d130f1e&scoped=true"
import script from "./exitBlacklist.vue?vue&type=script&lang=js"
export * from "./exitBlacklist.vue?vue&type=script&lang=js"
import style0 from "./exitBlacklist.vue?vue&type=style&index=0&id=0d130f1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d130f1e",
  null
  
)

export default component.exports